import { useEffect, useState } from "react";
import { fetchPage } from "@/lib/api";
import SEO from "@/components/SEO";
import Section from "@/components/Section";
import LatestPublicationsCarousel from "@/components/LatestPublicationsCarousel";
import { Loader2 } from "lucide-react";

export default function Resources() {
  const [page, setPage] = useState(null);
  const [err, setErr] = useState(null);

  useEffect(() => {
    if (typeof window !== "undefined") window.__prerender_ready = false;
    fetchPage("resources").then(setPage).catch((e) => setErr(e?.message || "Failed to load"));
  }, []);

  useEffect(() => {
    if (page?.meta_description) {
      const t = setTimeout(() => {
        if (typeof window !== "undefined") window.__prerender_ready = true;
      }, 50);
      return () => clearTimeout(t);
    }
  }, [page?.meta_description]);

  if (err) return <div className="aoa-container py-32 text-center"><p className="aoa-muted">{err}</p></div>;
  if (!page) return <div className="aoa-container py-32 flex items-center justify-center text-slate-400"><Loader2 className="h-5 w-5 animate-spin" /></div>;

  const sections = page.sections || [];
  // Insert carousel after the intro hero (first section), before the downloads/categories.
  return (
    <>
      <SEO title={page.title} description={page.meta_description} ogImage={page.og_image} path={page.route} />
      <div data-testid="page-resources">
        {sections[0] && <Section key={sections[0].key} section={sections[0]} pageTitle={page.title} isFirst />}
        <LatestPublicationsCarousel />
        {sections.slice(1).map((s) => (
          <Section key={s.key} section={s} pageTitle={page.title} />
        ))}
      </div>
    </>
  );
}
